exports.getMediaForSlideSuccessData = ->
  {
    totalCount: 2
    items: [
      {
        lessonId: "1"
        slideId: "1"
        id: "1"
        title: "Techniques we've used"
        description: "It's great"
        url: "video/example.mp4"
      },
      {
        lessonId: "2"
        slideId: "2"
        id: "2"
        title: "Try this other technique"
        description: "It's great"
        url: "video/example.mp4"
      },
      {
        lessonId: "2"
        slideId: "2"
        id: "2"
        title: "How about this?"
        description: "It's great"
        url: "video/example.mp4"
      },
      {
        lessonId: "2"
        slideId: "2"
        id: "2"
        title: "This is the best one"
        description: "It's great"
        url: "video/example.mp4"
      }
    ]
  }

exports.getNoMediaForSlideData = ->
  {
    totalCount: 0
    items: []
  }